angular.module('app').directive('modalEstornarMovimentacao', function($http) {
	return {
        restrict: 'E',
        templateUrl: '/html/modal-estornar-movimentacao.html?v='+angular.element('meta[name="version-id"]').attr('content'),
        controller: function($scope) {
            $scope.movimentacao = {};

            $scope.init = function(movimentacao_id){
                $scope.inicializando = true;

                $scope.movimentacao = {
                    id: movimentacao_id
                };    

                $scope.getDetalhesMovimentacao();
            }

            $scope.getDetalhesMovimentacao = function(){
                $http({
                    'url': 'admin/movimentacoes/'+$scope.movimentacao.id
                }).then(function(res){
                    $scope.movimentacao = res.data;
                    $scope.inicializando = false;
                });
            }

            $scope.salvar = function(e){
                e.preventDefault();
                $scope.cancelando = true;
                $http({
                    'url': 'admin/movimentacoes/'+$scope.movimentacao.id+'/estornar',
                    'method': 'post',
                    'data': $scope.movimentacao
                }).then(function(res){
                    if(res.data.status){
                        window.location.reload();
                    }
                }).catch(function(err){
                    $scope.cancelando = false;
                });
            }
        
        },
        link: function ($scope) {
           
        }
    };
});